export enum UserActionType {
  SHARE = 'share',
  SHARE_SOCIAL = 'shareSocial',
  SAVE = 'save',
  REPORT = 'report',
  APPEAL = 'appeal',
  BLOCK = 'block',
  SETTINGS = 'settings',
  HELP_ABOUT = 'helpAbout',
  LOGOUT = 'logout',
  DELETE_ACCOUNT = 'deleteAccount',
  EDIT = 'edit',
}
